import React, { useState } from "react";
import { gallery } from "../mock/mock";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { PageHero } from "./About";

const categories = ["All", "Campus", "Classrooms", "Library", "Events"];

const Gallery = () => {
  const [active, setActive] = useState("All");
  const [lightbox, setLightbox] = useState(null);

  const filtered = active === "All" ? gallery : gallery.filter((g) => g.category === active);

  const openImage = (idx) => setLightbox(idx);
  const closeImage = () => setLightbox(null);
  const next = (e) => {
    e?.stopPropagation();
    setLightbox((i) => (i + 1) % filtered.length);
  };
  const prev = (e) => {
    e?.stopPropagation();
    setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
  };

  return (
    <div>
      <PageHero
        eyebrow="Gallery"
        title="Moments from campus"
        subtitle="A window into our vibrant academic community, events and everyday life."
        image="https://images.unsplash.com/photo-1607013407627-6ee814329547"
      />

      <section className="section-y bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm font-medium border transition-colors ${
                  active === c
                    ? "bg-brand-green-deep text-brand-gold border-brand-green-deep"
                    : "bg-white text-brand-green-deep border-brand-gold/40 hover:bg-brand-ivory"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filtered.map((g, i) => (
              <button
                key={g.id}
                onClick={() => openImage(i)}
                className="relative group overflow-hidden rounded-sm aspect-[4/3] animate-fade-up"
                style={{ animationDelay: `${i * 0.04}s` }}
              >
                <img
                  src={g.image}
                  alt={g.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-green-deep/90 via-brand-green-deep/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-3 left-3 right-3 text-left translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <div className="text-[10px] uppercase tracking-widest text-brand-gold font-bold mb-1">{g.category}</div>
                  <div className="font-serif-display text-brand-ivory text-lg leading-tight">{g.title}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && filtered[lightbox] && (
        <div
          className="fixed inset-0 z-[100] bg-brand-green-deep/95 backdrop-blur flex items-center justify-center p-4 animate-fade-in"
          onClick={closeImage}
        >
          <button
            onClick={closeImage}
            className="absolute top-6 right-6 w-11 h-11 rounded-full border border-brand-gold/50 text-brand-ivory hover:bg-brand-gold hover:text-brand-green-deep transition-colors flex items-center justify-center"
          >
            <X className="w-5 h-5" />
          </button>
          <button
            onClick={prev}
            className="absolute left-4 md:left-8 w-12 h-12 rounded-full border border-brand-gold/50 text-brand-ivory hover:bg-brand-gold hover:text-brand-green-deep transition-colors flex items-center justify-center"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={next}
            className="absolute right-4 md:right-8 w-12 h-12 rounded-full border border-brand-gold/50 text-brand-ivory hover:bg-brand-gold hover:text-brand-green-deep transition-colors flex items-center justify-center"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
          <div className="max-w-5xl max-h-[85vh] w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={filtered[lightbox].image}
              alt={filtered[lightbox].title}
              className="w-full h-full object-contain rounded-sm shadow-2xl"
            />
            <div className="mt-4 text-center">
              <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">{filtered[lightbox].category}</div>
              <div className="font-serif-display text-brand-ivory text-2xl mt-1">{filtered[lightbox].title}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
